import { useGetAvailableLeaveBalance, useGetUserInfo } from '../../../Core/Hooks/useTimereport';
import { useTranslation } from 'react-i18next';
import './TimereportUserOverview.scss';

const TimereportUserOverview = () => {
	const { t } = useTranslation();
	const { userInfo, statusState } = useGetUserInfo();
	const { availableBalance } = useGetAvailableLeaveBalance();

	const getLeaveBalance = (typeId: string): number | null => {
		if (!availableBalance) return null;
		return availableBalance[typeId] ?? null;
	};

	if (statusState === 'LOADING') return <p>{t('TIMEREPORT_USER.OVERVIEW.STATE.LOADING')}</p>;
	if (!userInfo) return <p>{t('TIMEREPORT_USER.OVERVIEW.STATE.NO_USER_INFO')}</p>;

	return (
		<div className='biz-timereport-user-overview'>
			<h3>{t('TIMEREPORT_USER.OVERVIEW.SUMMARY.TITLE')}</h3>

			<div className='biz-timereport-user-overview__cards'>
				{userInfo.normalWeekHours > 0 && (
					<>
						{/** NONE OF THIS WORKS WITH NO WORK HOURS **/}
						<div className='biz-timereport-user-overview__card overview-card--weekly-hours'>
							<span className='biz-timereport-user-overview__card-label'>
								{t('TIMEREPORT_USER.OVERVIEW.SUMMARY.CARDS.WEEKLY_HOURS')}
							</span>
							<span className='biz-timereport-user-overview__card-value'>{userInfo.normalWeekHours}</span>
						</div>
						<div className='biz-timereport-user-overview__card overview-card--flex-bank'>
							<span className='biz-timereport-user-overview__card-label'>
								{t('TIMEREPORT_USER.OVERVIEW.SUMMARY.CARDS.FLEX_BANK')}
							</span>
							<span className='biz-timereport-user-overview__card-value'>{userInfo.flexBank}h</span>
						</div>
						<div className='biz-timereport-user-overview__card overview-card--vacation-days-per-year'>
							<span className='biz-timereport-user-overview__card-label'>
								{t('TIMEREPORT_USER.OVERVIEW.SUMMARY.CARDS.VACATION_DAYS_PER_YEAR')}
							</span>
							<span className='biz-timereport-user-overview__card-value'>{userInfo.vacationDaysPerYear}</span>
						</div>
						<div className='biz-timereport-user-overview__card overview-card--vacation-balance'>
							<span className='biz-timereport-user-overview__card-label'>
								{t('TIMEREPORT_USER.OVERVIEW.SUMMARY.CARDS.VACATION_BALANCE')}
							</span>
							<span className='biz-timereport-user-overview__card-value'>
								{getLeaveBalance('paidVacation') ?? userInfo.vacationDaysPaidLeft}
								{getLeaveBalance('paidVacation') !== null &&
									getLeaveBalance('paidVacation') !== userInfo.vacationDaysPaidLeft && (
										<span className='biz-timereport-user-overview__card-pending'>
											(
											{t('TIMEREPORT_USER.OVERVIEW.SUMMARY.CARDS.PENDING', {
												count: userInfo.vacationDaysPaidLeft - (getLeaveBalance('paidVacation') ?? 0),
											})}
											)
										</span>
									)}
							</span>
						</div>
						<div className='biz-timereport-user-overview__card overview-card--saved-hours'>
							<span className='biz-timereport-user-overview__card-label'>
								{t('TIMEREPORT_USER.OVERVIEW.SUMMARY.CARDS.SAVED_HOURS')}
							</span>
							<span className='biz-timereport-user-overview__card-value'>{userInfo.savedHours}h</span>
						</div>
					</>
				)}
				{userInfo.dateTimeReportFlag && (
					<div className='biz-timereport-user-overview__card overview-card--last-submitted'>
						<span className='biz-timereport-user-overview__card-label'>
							{t('TIMEREPORT_USER.OVERVIEW.SUMMARY.CARDS.LAST_SUBMITTED')}
						</span>
						<span className='biz-timereport-user-overview__card-value'>
							{userInfo.dateTimeReportFlag.split('T')[0]}
						</span>
					</div>
				)}
			</div>
		</div>
	);
};

export default TimereportUserOverview;
